<template>
  <svg
    width="168"
    height="160"
    viewBox="0 0 168 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.1"
      d="M84 140C117.137 140 144 113.137 144 80C144 46.8629 117.137 20 84 20C50.8629 20 24 46.8629 24 80C24 113.137 50.8629 140 84 140Z"
      fill="url(#paint0_linear_10083_74008)"
    />
    <g filter="url(#filter0_d_10083_74008)">
      <path
        d="M106.929 129.541H24.0672C21.8365 129.541 19.9995 127.703 19.9995 125.47V76.6233C19.9995 74.3911 21.8365 72.5527 24.0672 72.5527H106.929C109.16 72.5527 110.997 74.3911 110.997 76.6233V125.47C110.997 127.703 109.16 129.541 106.929 129.541Z"
        fill="url(#paint1_linear_10083_74008)"
      />
    </g>
    <path
      d="M43.5267 97.2705C43.0881 97.1565 42.7471 96.7742 42.7422 96.3219L42.6906 91.599C42.685 91.0861 43.1089 90.6832 43.6162 90.7528C50.3735 91.68 55.5741 97.4466 55.7256 104.273C55.7933 108.52 53.736 112.308 50.5175 114.669C50.1097 114.968 49.5313 114.811 49.2746 114.357L46.8248 110.031C46.5982 109.631 46.7055 109.137 47.031 108.832C48.289 107.651 49.0327 105.948 49.0611 103.966C49.0378 100.861 46.6125 98.0724 43.5267 97.2705Z"
      fill="url(#paint2_linear_10083_74008)"
    />
    <path
      opacity="0.14"
      d="M40.3223 90.8878C40.8311 90.8346 41.2687 91.2556 41.2743 91.7718L41.3249 96.4166C41.3299 96.876 40.987 97.248 40.5424 97.34C39.0743 97.6435 37.7531 98.4287 36.8006 99.5655C36.4863 99.9406 35.9367 100.057 35.5173 99.7796L31.5241 97.1342C31.1045 96.8563 30.9777 96.2923 31.2727 95.9012C33.3379 93.1634 36.5143 91.2861 40.3223 90.8878Z"
      fill="url(#paint3_linear_10083_74008)"
    />
    <path
      opacity="0.24"
      d="M29.1934 99.2192C29.3824 98.731 29.9735 98.5781 30.4222 98.8691L34.6524 101.613C34.9938 101.835 35.1453 102.251 35.0533 102.641C34.9488 103.082 34.8833 103.548 34.9346 104.085C34.9297 107.81 38.1358 110.946 42.1166 111.104C42.9202 111.093 43.6565 111.004 44.3256 110.837C44.7467 110.732 45.2084 110.901 45.4316 111.286L47.8436 115.444C48.1088 115.901 47.9386 116.479 47.4578 116.662C45.8288 117.281 44.0422 117.583 42.1863 117.498C34.6244 117.356 28.4754 111.246 28.3387 103.914C28.3489 102.27 28.6375 100.656 29.1934 99.2192Z"
      fill="url(#paint4_linear_10083_74008)"
    />
    <path
      opacity="0.24"
      d="M63.5631 81.8759H28.0038C27.0197 81.8759 26.2324 81.0881 26.2324 80.1032C26.2324 79.1184 27.0197 78.3306 28.0038 78.3306H63.6287C64.6128 78.3306 65.4001 79.1184 65.4001 80.1032C65.4001 81.0881 64.5472 81.8759 63.5631 81.8759Z"
      fill="url(#paint5_linear_10083_74008)"
    />
    <g filter="url(#filter1_d_10083_74008)">
      <path
        d="M143.932 86.9312H61.0701C58.8394 86.9312 57.0024 85.0928 57.0024 82.8606V34.0135C57.0024 31.7812 58.8394 29.9429 61.0701 29.9429H143.932C146.163 29.9429 148 31.7812 148 34.0135V82.8606C148 85.0928 146.163 86.9312 143.932 86.9312Z"
        fill="url(#paint6_linear_10083_74008)"
      />
    </g>
    <path
      opacity="0.24"
      d="M100.565 39.2658H65.0058C64.0217 39.2658 63.2344 38.478 63.2344 37.4931C63.2344 36.5083 64.0217 35.7205 65.0058 35.7205H100.631C101.615 35.7205 102.402 36.5083 102.402 37.4931C102.402 38.478 101.549 39.2658 100.565 39.2658Z"
      fill="url(#paint7_linear_10083_74008)"
    />
    <path
      d="M79.6377 80.3658H76.0946C75.5696 80.3658 75.1104 79.9062 75.1104 79.3809C75.1104 78.8556 75.5696 78.396 76.0946 78.396H79.6377C80.1626 78.396 80.6219 78.8556 80.6219 79.3809C80.6875 79.9062 80.2282 80.3658 79.6377 80.3658Z"
      fill="url(#paint8_linear_10083_74008)"
    />
    <path
      d="M99.647 80.3658H96.1038C95.5789 80.3658 95.1196 79.9062 95.1196 79.3809C95.1196 78.8556 95.5789 78.396 96.1038 78.396H99.647C100.172 78.396 100.631 78.8556 100.631 79.3809C100.631 79.9062 100.172 80.3658 99.647 80.3658Z"
      fill="url(#paint9_linear_10083_74008)"
    />
    <path
      opacity="0.24"
      d="M92.1266 108.617H78.1278C77.6685 108.617 77.2749 108.223 77.2749 107.763V107.632C77.2749 107.172 77.6685 106.778 78.1278 106.778H92.1266C92.5859 106.778 92.9795 107.172 92.9795 107.632V107.763C92.9795 108.223 92.5859 108.617 92.1266 108.617Z"
      fill="url(#paint10_linear_10083_74008)"
    />
    <path
      opacity="0.24"
      d="M85.6513 100.517H78.1278C77.6685 100.517 77.2749 100.123 77.2749 99.663V99.5317C77.2749 99.0722 77.6685 98.6782 78.1278 98.6782H85.6513C86.1105 98.6782 86.5042 99.0722 86.5042 99.5317V99.663C86.5042 100.123 86.1105 100.517 85.6513 100.517Z"
      fill="url(#paint11_linear_10083_74008)"
    />
    <path
      opacity="0.24"
      d="M89.3268 116.495H78.1278C77.6685 116.495 77.2749 116.101 77.2749 115.642V115.51C77.2749 115.051 77.6685 114.657 78.1278 114.657H89.3268C89.7861 114.657 90.1797 115.051 90.1797 115.51C90.1797 115.598 90.1901 115.685 90.1862 115.773C90.1681 116.174 89.801 116.495 89.3268 116.495Z"
      fill="url(#paint12_linear_10083_74008)"
    />
    <path
      d="M119.658 80.3658H116.115C115.59 80.3658 115.131 79.9062 115.131 79.3809C115.131 78.8556 115.59 78.396 116.115 78.396H119.658C120.183 78.396 120.642 78.8556 120.642 79.3809C120.708 79.9062 120.249 80.3658 119.658 80.3658Z"
      fill="url(#paint13_linear_10083_74008)"
    />
    <path
      d="M139.865 80.3658H136.322C135.797 80.3658 135.338 79.9062 135.338 79.3809C135.338 78.8556 135.797 78.396 136.322 78.396H139.865C140.39 78.396 140.849 78.8556 140.849 79.3809C140.849 79.9062 140.456 80.3658 139.865 80.3658Z"
      fill="url(#paint14_linear_10083_74008)"
    />
    <path
      opacity="0.24"
      d="M67.4342 72.0934H64.5472C64.0223 72.0934 63.563 71.6337 63.563 71.1085C63.563 70.5832 64.0223 70.1235 64.5472 70.1235H67.4342C67.9591 70.1235 68.4184 70.5832 68.4184 71.1085C68.4184 71.6994 67.9591 72.0934 67.4342 72.0934Z"
      fill="url(#paint15_linear_10083_74008)"
    />
    <path
      opacity="0.24"
      d="M67.4342 60.3412H64.5472C64.0223 60.3412 63.563 59.8815 63.563 59.3563C63.563 58.831 64.0223 58.3713 64.5472 58.3713H67.4342C67.9591 58.3713 68.4184 58.831 68.4184 59.3563C68.4184 59.8815 67.9591 60.3412 67.4342 60.3412Z"
      fill="url(#paint16_linear_10083_74008)"
    />
    <path
      opacity="0.24"
      d="M67.4342 48.589H64.5472C64.0223 48.589 63.563 48.1293 63.563 47.6041C63.563 47.0788 64.0223 46.6191 64.5472 46.6191H67.4342C67.9591 46.6191 68.4184 47.0788 68.4184 47.6041C68.4184 48.1293 67.9591 48.589 67.4342 48.589Z"
      fill="url(#paint17_linear_10083_74008)"
    />
    <path
      opacity="0.24"
      d="M74.1256 58.5027H73.4699C73.2886 58.5027 73.1416 58.6497 73.1416 58.831C73.1416 59.0123 73.2886 59.1593 73.4699 59.1593H74.1256C74.3069 59.1593 74.4539 59.0123 74.4539 58.831C74.4539 58.6497 74.3069 58.5027 74.1256 58.5027Z"
      fill="url(#paint18_linear_10083_74008)"
    />
    <path
      opacity="0.24"
      d="M137.831 58.831C137.831 59.0123 137.684 59.1592 137.502 59.1592H135.535C135.353 59.1592 135.206 59.0123 135.206 58.831C135.206 58.6497 135.353 58.5027 135.535 58.5027H137.502C137.684 58.5027 137.831 58.6497 137.831 58.831ZM132.582 58.831C132.582 59.0123 132.435 59.1592 132.254 59.1592H130.286C130.105 59.1592 129.958 59.0123 129.958 58.831C129.958 58.6497 130.105 58.5027 130.286 58.5027H132.254C132.435 58.5027 132.582 58.6497 132.582 58.831ZM127.268 58.831C127.268 59.0123 127.121 59.1592 126.94 59.1592H124.972C124.791 59.1592 124.644 59.0123 124.644 58.831C124.644 58.6497 124.791 58.5027 124.972 58.5027H126.94C127.121 58.5027 127.268 58.6497 127.268 58.831ZM122.019 58.831C122.019 59.0123 121.872 59.1592 121.691 59.1592H119.723C119.542 59.1592 119.395 59.0123 119.395 58.831C119.395 58.6497 119.542 58.5027 119.723 58.5027H121.691C121.872 58.5027 122.019 58.6497 122.019 58.831ZM116.705 58.831C116.705 59.0123 116.558 59.1592 116.377 59.1592H114.409C114.228 59.1592 114.081 59.0123 114.081 58.831C114.081 58.6497 114.228 58.5027 114.409 58.5027H116.377C116.558 58.5027 116.705 58.6497 116.705 58.831ZM111.456 58.831C111.456 59.0123 111.309 59.1592 111.128 59.1592H109.16C108.979 59.1592 108.832 59.0123 108.832 58.831C108.832 58.6497 108.979 58.5027 109.16 58.5027H111.128C111.309 58.5027 111.456 58.6497 111.456 58.831ZM106.142 58.831C106.142 59.0123 105.995 59.1592 105.814 59.1592H103.846C103.665 59.1592 103.518 59.0123 103.518 58.831C103.518 58.6497 103.665 58.5027 103.846 58.5027H105.814C105.995 58.5027 106.142 58.6497 106.142 58.831ZM100.894 58.831C100.894 59.0123 100.747 59.1592 100.565 59.1592H98.5976C98.4163 59.1592 98.2694 59.0123 98.2694 58.831C98.2694 58.6497 98.4163 58.5027 98.5976 58.5027H100.565C100.747 58.5027 100.894 58.6497 100.894 58.831ZM95.5794 58.831C95.5794 59.0123 95.4325 59.1592 95.2512 59.1592H93.2834C93.1021 59.1592 92.9551 59.0123 92.9551 58.831C92.9551 58.6497 93.1021 58.5027 93.2834 58.5027H95.2512C95.4325 58.5027 95.5794 58.6497 95.5794 58.831ZM90.3308 58.831C90.3308 59.0123 90.1839 59.1592 90.0026 59.1592H88.0348C87.8535 59.1592 87.7065 59.0123 87.7065 58.831C87.7065 58.6497 87.8535 58.5027 88.0348 58.5027H90.0026C90.1839 58.5027 90.3308 58.6497 90.3308 58.831ZM85.0166 58.831C85.0166 59.0123 84.8697 59.1592 84.6884 59.1592H82.7206C82.5393 59.1592 82.3923 59.0123 82.3923 58.831C82.3923 58.6497 82.5393 58.5027 82.7206 58.5027H84.6884C84.8697 58.5027 85.0166 58.6497 85.0166 58.831ZM79.7024 58.831C79.7024 59.0123 79.5555 59.1592 79.3742 59.1592H77.4064C77.2251 59.1592 77.0781 59.0123 77.0781 58.831C77.0781 58.6497 77.2251 58.5027 77.4064 58.5027H79.3742C79.5555 58.5027 79.7024 58.6497 79.7024 58.831Z"
      fill="url(#paint19_linear_10083_74008)"
    />
    <path d="M141.832 58.5027H140.52V59.1593H141.832V58.5027Z" fill="#C2C8D6" />
    <path
      opacity="0.24"
      d="M74.1256 46.6848H73.4699C73.2886 46.6848 73.1416 46.8318 73.1416 47.0131C73.1416 47.1944 73.2886 47.3414 73.4699 47.3414H74.1256C74.3069 47.3414 74.4539 47.1944 74.4539 47.0131C74.4539 46.8318 74.3069 46.6848 74.1256 46.6848Z"
      fill="url(#paint20_linear_10083_74008)"
    />
    <path
      opacity="0.24"
      d="M137.831 47.0131C137.831 47.1944 137.684 47.3414 137.502 47.3414H135.535C135.353 47.3414 135.206 47.1944 135.206 47.0131C135.206 46.8318 135.353 46.6848 135.535 46.6848H137.502C137.684 46.6848 137.831 46.8318 137.831 47.0131ZM132.582 47.0131C132.582 47.1944 132.435 47.3414 132.254 47.3414H130.286C130.105 47.3414 129.958 47.1944 129.958 47.0131C129.958 46.8318 130.105 46.6848 130.286 46.6848H132.254C132.435 46.6848 132.582 46.8318 132.582 47.0131ZM127.268 47.0131C127.268 47.1944 127.121 47.3414 126.94 47.3414H124.972C124.791 47.3414 124.644 47.1944 124.644 47.0131C124.644 46.8318 124.791 46.6848 124.972 46.6848H126.94C127.121 46.6848 127.268 46.8318 127.268 47.0131ZM122.019 47.0131C122.019 47.1944 121.872 47.3414 121.691 47.3414H119.723C119.542 47.3414 119.395 47.1944 119.395 47.0131C119.395 46.8318 119.542 46.6848 119.723 46.6848H121.691C121.872 46.6848 122.019 46.8318 122.019 47.0131ZM116.705 47.0131C116.705 47.1944 116.558 47.3414 116.377 47.3414H114.409C114.228 47.3414 114.081 47.1944 114.081 47.0131C114.081 46.8318 114.228 46.6848 114.409 46.6848H116.377C116.558 46.6848 116.705 46.8318 116.705 47.0131ZM111.456 47.0131C111.456 47.1944 111.309 47.3414 111.128 47.3414H109.16C108.979 47.3414 108.832 47.1944 108.832 47.0131C108.832 46.8318 108.979 46.6848 109.16 46.6848H111.128C111.309 46.6848 111.456 46.8318 111.456 47.0131ZM106.142 47.0131C106.142 47.1944 105.995 47.3414 105.814 47.3414H103.846C103.665 47.3414 103.518 47.1944 103.518 47.0131C103.518 46.8318 103.665 46.6848 103.846 46.6848H105.814C105.995 46.6848 106.142 46.8318 106.142 47.0131ZM100.894 47.0131C100.894 47.1944 100.747 47.3414 100.565 47.3414H98.5976C98.4163 47.3414 98.2694 47.1944 98.2694 47.0131C98.2694 46.8318 98.4163 46.6848 98.5976 46.6848H100.565C100.747 46.6848 100.894 46.8318 100.894 47.0131ZM95.5794 47.0131C95.5794 47.1944 95.4325 47.3414 95.2512 47.3414H93.2834C93.1021 47.3414 92.9551 47.1944 92.9551 47.0131C92.9551 46.8318 93.1021 46.6848 93.2834 46.6848H95.2512C95.4325 46.6848 95.5794 46.8318 95.5794 47.0131ZM90.3308 47.0131C90.3308 47.1944 90.1839 47.3414 90.0026 47.3414H88.0348C87.8535 47.3414 87.7065 47.1944 87.7065 47.0131C87.7065 46.8318 87.8535 46.6848 88.0348 46.6848H90.0026C90.1839 46.6848 90.3308 46.8318 90.3308 47.0131ZM85.0166 47.0131C85.0166 47.1944 84.8697 47.3414 84.6884 47.3414H82.7206C82.5393 47.3414 82.3923 47.1944 82.3923 47.0131C82.3923 46.8318 82.5393 46.6848 82.7206 46.6848H84.6884C84.8697 46.6848 85.0166 46.8318 85.0166 47.0131ZM79.7024 47.0131C79.7024 47.1944 79.5555 47.3414 79.3742 47.3414H77.4064C77.2251 47.3414 77.0781 47.1944 77.0781 47.0131C77.0781 46.8318 77.2251 46.6848 77.4064 46.6848H79.3742C79.5555 46.6848 79.7024 46.8318 79.7024 47.0131Z"
      fill="url(#paint21_linear_10083_74008)"
    />
    <path
      opacity="0.24"
      d="M141.504 46.6848H140.849C140.667 46.6848 140.521 46.8318 140.521 47.0131C140.521 47.1944 140.667 47.3414 140.849 47.3414H141.504C141.686 47.3414 141.833 47.1944 141.833 47.0131C141.833 46.8318 141.686 46.6848 141.504 46.6848Z"
      fill="url(#paint22_linear_10083_74008)"
    />
    <path
      opacity="0.24"
      d="M74.1256 71.7432H73.4699C73.2886 71.7432 73.1416 71.8902 73.1416 72.0715C73.1416 72.2528 73.2886 72.3998 73.4699 72.3998H74.1256C74.3069 72.3998 74.4539 72.2528 74.4539 72.0715C74.4539 71.8902 74.3069 71.7432 74.1256 71.7432Z"
      fill="url(#paint23_linear_10083_74008)"
    />
    <path
      opacity="0.24"
      d="M137.831 72.0714C137.831 72.2527 137.684 72.3997 137.502 72.3997H135.535C135.353 72.3997 135.206 72.2527 135.206 72.0714C135.206 71.8901 135.353 71.7432 135.535 71.7432H137.502C137.684 71.7432 137.831 71.8901 137.831 72.0714ZM132.582 72.0714C132.582 72.2527 132.435 72.3997 132.254 72.3997H130.286C130.105 72.3997 129.958 72.2527 129.958 72.0714C129.958 71.8901 130.105 71.7432 130.286 71.7432H132.254C132.435 71.7432 132.582 71.8901 132.582 72.0714ZM127.268 72.0714C127.268 72.2527 127.121 72.3997 126.94 72.3997H124.972C124.791 72.3997 124.644 72.2527 124.644 72.0714C124.644 71.8901 124.791 71.7432 124.972 71.7432H126.94C127.121 71.7432 127.268 71.8901 127.268 72.0714ZM122.019 72.0714C122.019 72.2527 121.872 72.3997 121.691 72.3997H119.723C119.542 72.3997 119.395 72.2527 119.395 72.0714C119.395 71.8901 119.542 71.7432 119.723 71.7432H121.691C121.872 71.7432 122.019 71.8901 122.019 72.0714ZM116.705 72.0714C116.705 72.2527 116.558 72.3997 116.377 72.3997H114.409C114.228 72.3997 114.081 72.2527 114.081 72.0714C114.081 71.8901 114.228 71.7432 114.409 71.7432H116.377C116.558 71.7432 116.705 71.8901 116.705 72.0714ZM111.456 72.0714C111.456 72.2527 111.309 72.3997 111.128 72.3997H109.16C108.979 72.3997 108.832 72.2527 108.832 72.0714C108.832 71.8901 108.979 71.7432 109.16 71.7432H111.128C111.309 71.7432 111.456 71.8901 111.456 72.0714ZM106.142 72.0714C106.142 72.2527 105.995 72.3997 105.814 72.3997H103.846C103.665 72.3997 103.518 72.2527 103.518 72.0714C103.518 71.8901 103.665 71.7432 103.846 71.7432H105.814C105.995 71.7432 106.142 71.8901 106.142 72.0714ZM100.894 72.0714C100.894 72.2527 100.747 72.3997 100.565 72.3997H98.5976C98.4163 72.3997 98.2694 72.2527 98.2694 72.0714C98.2694 71.8901 98.4163 71.7432 98.5976 71.7432H100.565C100.747 71.7432 100.894 71.8901 100.894 72.0714ZM95.5794 72.0714C95.5794 72.2527 95.4325 72.3997 95.2512 72.3997H93.2834C93.1021 72.3997 92.9551 72.2527 92.9551 72.0714C92.9551 71.8901 93.1021 71.7432 93.2834 71.7432H95.2512C95.4325 71.7432 95.5794 71.8901 95.5794 72.0714ZM90.3308 72.0714C90.3308 72.2527 90.1839 72.3997 90.0026 72.3997H88.0348C87.8535 72.3997 87.7065 72.2527 87.7065 72.0714C87.7065 71.8901 87.8535 71.7432 88.0348 71.7432H90.0026C90.1839 71.7432 90.3308 71.8901 90.3308 72.0714ZM85.0166 72.0714C85.0166 72.2527 84.8697 72.3997 84.6884 72.3997H82.7206C82.5393 72.3997 82.3923 72.2527 82.3923 72.0714C82.3923 71.8901 82.5393 71.7432 82.7206 71.7432H84.6884C84.8697 71.7432 85.0166 71.8901 85.0166 72.0714ZM79.7024 72.0714C79.7024 72.2527 79.5555 72.3997 79.3742 72.3997H77.4064C77.2251 72.3997 77.0781 72.2527 77.0781 72.0714C77.0781 71.8901 77.2251 71.7432 77.4064 71.7432H79.3742C79.5555 71.7432 79.7024 71.8901 79.7024 72.0714Z"
      fill="url(#paint24_linear_10083_74008)"
    />
    <path
      opacity="0.24"
      d="M141.504 71.7432H140.849C140.667 71.7432 140.521 71.8902 140.521 72.0715C140.521 72.2528 140.667 72.3998 140.849 72.3998H141.504C141.686 72.3998 141.833 72.2528 141.833 72.0715C141.833 71.8902 141.686 71.7432 141.504 71.7432Z"
      fill="url(#paint25_linear_10083_74008)"
    />
    <path
      opacity="0.94"
      d="M72.0267 109.667H70.2551C69.5989 109.667 69.1396 109.142 69.1396 108.551V106.778C69.1396 106.122 69.6646 105.662 70.2551 105.662H72.0267C72.6828 105.662 73.1421 106.187 73.1421 106.778V108.551C73.1421 109.208 72.6172 109.667 72.0267 109.667Z"
      fill="url(#paint26_linear_10083_74008)"
    />
    <path
      d="M72.0267 101.568H70.2551C69.5989 101.568 69.1396 101.042 69.1396 100.451V98.6785C69.1396 98.0219 69.6646 97.5623 70.2551 97.5623H72.0267C72.6828 97.5623 73.1421 98.0875 73.1421 98.6785V100.451C73.1421 101.108 72.6172 101.568 72.0267 101.568Z"
      fill="#EAEEF9"
    />
    <path
      opacity="0.64"
      d="M72.0267 117.546H70.2551C69.5989 117.546 69.1396 117.021 69.1396 116.43V114.657C69.1396 114 69.6646 113.541 70.2551 113.541H72.0267C72.6828 113.541 73.1421 114.066 73.1421 114.657V116.43C73.1421 117.086 72.6172 117.546 72.0267 117.546Z"
      fill="url(#paint27_linear_10083_74008)"
    />
    <path
      opacity="0.5"
      d="M79.8993 57.7805H75.9628C74.9787 57.7805 74.1914 58.5684 74.1914 59.5532V69.4256C74.1914 69.9199 74.5921 70.3206 75.0863 70.3206H80.7757C81.27 70.3206 81.6707 69.9199 81.6707 69.4256V59.5532C81.6707 58.5684 80.8834 57.7805 79.8993 57.7805Z"
      fill="url(#paint28_linear_10083_74008)"
    />
    <path
      opacity="0.5"
      d="M99.8436 52.3311H95.9071C94.923 52.3311 94.1357 53.1189 94.1357 54.1037V69.3599C94.1357 69.8541 94.5364 70.2548 95.0307 70.2548H100.786C101.28 70.2548 101.681 69.8541 101.681 69.3599V54.1037C101.615 53.1189 100.828 52.3311 99.8436 52.3311Z"
      fill="url(#paint29_linear_10083_74008)"
    />
    <path
      opacity="0.5"
      d="M119.92 65.1338H115.983C114.999 65.1338 114.212 65.9217 114.212 66.9066V69.3604C114.212 69.8547 114.613 70.2554 115.107 70.2554H120.797C121.291 70.2554 121.692 69.8547 121.692 69.3604V66.9066C121.692 65.9217 120.905 65.1338 119.92 65.1338Z"
      fill="url(#paint30_linear_10083_74008)"
    />
    <path
      opacity="0.5"
      d="M140.061 48.5232H136.124C135.14 48.5232 134.353 49.3111 134.353 50.2959V69.4256C134.353 69.9199 134.754 70.3206 135.248 70.3206H141.003C141.497 70.3206 141.898 69.9199 141.898 69.4256V50.2959C141.832 49.3111 141.045 48.5232 140.061 48.5232Z"
      fill="url(#paint31_linear_10083_74008)"
    />
    <defs>
      <filter
        id="filter0_d_10083_74008"
        x="0.310863"
        y="62.7084"
        width="130.375"
        height="96.3656"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="9.84432" />
        <feGaussianBlur stdDeviation="9.84432" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_74008"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_74008"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_10083_74008"
        x="37.3138"
        y="20.0985"
        width="130.375"
        height="96.3656"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="9.84432" />
        <feGaussianBlur stdDeviation="9.84432" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_74008"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_74008"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_10083_74008"
        x1="23.9981"
        y1="139.999"
        x2="143.999"
        y2="19.9985"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_10083_74008"
        x1="65.4687"
        y1="71.2345"
        x2="65.4687"
        y2="130.155"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_10083_74008"
        x1="54.914"
        y1="115.742"
        x2="34.9442"
        y2="101.48"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_10083_74008"
        x1="41.0654"
        y1="100.795"
        x2="32.0129"
        y2="89.1831"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_10083_74008"
        x1="48.1923"
        y1="118.193"
        x2="32.3932"
        y2="95.6669"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_10083_74008"
        x1="26.2318"
        y1="81.8759"
        x2="26.8684"
        y2="74.8428"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_10083_74008"
        x1="102.472"
        y1="28.6247"
        x2="102.472"
        y2="87.5455"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_10083_74008"
        x1="63.2338"
        y1="39.2658"
        x2="63.8704"
        y2="32.2327"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_10083_74008"
        x1="75.1103"
        y1="80.3658"
        x2="76.3577"
        y2="76.8715"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_10083_74008"
        x1="95.1195"
        y1="80.3658"
        x2="96.3681"
        y2="76.8724"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_10083_74008"
        x1="77.2747"
        y1="108.617"
        x2="77.6992"
        y2="104.99"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_10083_74008"
        x1="77.2748"
        y1="100.517"
        x2="77.9791"
        y2="96.9802"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_10083_74008"
        x1="77.2747"
        y1="116.495"
        x2="77.7878"
        y2="112.892"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_10083_74008"
        x1="115.131"
        y1="80.3658"
        x2="116.378"
        y2="76.8715"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_10083_74008"
        x1="135.338"
        y1="80.3658"
        x2="136.586"
        y2="76.8724"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_10083_74008"
        x1="63.5629"
        y1="72.0934"
        x2="64.9353"
        y2="68.7105"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_10083_74008"
        x1="63.5629"
        y1="60.3412"
        x2="64.9353"
        y2="56.9583"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_10083_74008"
        x1="63.5629"
        y1="48.589"
        x2="64.9353"
        y2="45.2061"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_10083_74008"
        x1="73.1416"
        y1="59.1593"
        x2="73.6671"
        y2="58.109"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_10083_74008"
        x1="77.0772"
        y1="59.1592"
        x2="77.0914"
        y2="57.8463"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_10083_74008"
        x1="73.1416"
        y1="47.3414"
        x2="73.6671"
        y2="46.2911"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_10083_74008"
        x1="77.0772"
        y1="47.3414"
        x2="77.0914"
        y2="46.0284"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint22_linear_10083_74008"
        x1="140.52"
        y1="47.3414"
        x2="141.046"
        y2="46.2911"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint23_linear_10083_74008"
        x1="73.1416"
        y1="72.3998"
        x2="73.6671"
        y2="71.3495"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint24_linear_10083_74008"
        x1="77.0772"
        y1="72.3997"
        x2="77.0914"
        y2="71.0868"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint25_linear_10083_74008"
        x1="140.52"
        y1="72.3998"
        x2="141.046"
        y2="71.3495"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint26_linear_10083_74008"
        x1="69.1396"
        y1="109.667"
        x2="73.1449"
        y2="105.665"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint27_linear_10083_74008"
        x1="69.1396"
        y1="117.546"
        x2="73.1449"
        y2="113.544"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint28_linear_10083_74008"
        x1="74.1913"
        y1="70.3205"
        x2="85.2249"
        y2="63.7397"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint29_linear_10083_74008"
        x1="94.1356"
        y1="70.2547"
        x2="106.954"
        y2="64.8588"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint30_linear_10083_74008"
        x1="114.212"
        y1="70.2553"
        x2="118.987"
        y2="63.2816"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint31_linear_10083_74008"
        x1="134.353"
        y1="70.3204"
        x2="147.828"
        y2="65.6561"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup></script>
